export const ASSETS = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/4c424c00-adc9-4c8d-bc98-6c9b35978cb6/images/2dee53a91c17e47d27472d939ada0274a9a3c5ce04c6dcd4be8aac427085cc7a.jpeg",
  nedenBg:
    "https://static.prod-images.emergentagent.com/jobs/4c424c00-adc9-4c8d-bc98-6c9b35978cb6/images/ee93553532c202b35f160b8515f62ddf93d4bc2b1cc7f07c530db3c44ffb714c.jpeg",
  gelecekBg:
    "https://static.prod-images.emergentagent.com/jobs/4c424c00-adc9-4c8d-bc98-6c9b35978cb6/images/300cabde1960a3041991f4039b4a6b9b7ad269dd40c2ca4d6747ae4fb12ccc41.jpeg",
  historic:
    "https://static.prod-images.emergentagent.com/jobs/4c424c00-adc9-4c8d-bc98-6c9b35978cb6/images/89d91d2daff412891fe07fbded21391ebd2e789f0338ef480512e43f092d5250.jpeg",
  video:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_4c424c00-adc9-4c8d-bc98-6c9b35978cb6/artifacts/pwexp5od_sermayeai-tanitim-720.mp4",
};

export const NAV_ITEMS = [
  { label: "Anasayfa", target: "anasayfa" },
  { label: "Tarihçe", target: "tarihce" },
  { label: "Bugün", target: "bugun" },
  { label: "Neden Yatırım Yapmalı?", target: "neden" },
  { label: "Gelecek", target: "gelecek" },
  { label: "İletişim", target: "iletisim" },
];

export const CHART_DATA = [
  { year: "2019", v: 2600 },
  { year: "2020", v: 3100 },
  { year: "2021", v: 3500 },
  { year: "2022", v: 4300 },
  { year: "2023", v: 6100 },
  { year: "2024", v: 8200 },
];

export const PRIVACY = {
  title: "Gizlilik Politikası",
  updated: "Son Güncelleme Tarihi: 02.07.2024",
  sections: [
    {
      h: "1. Genel Bilgilendirme",
      p: ["Bu Gizlilik Politikası, web sitemizi, Facebook, Instagram, WhatsApp ve diğer dijital platformlarımızı ziyaret eden kullanıcıların kişisel verilerinin hangi amaçlarla toplandığını, işlendiğini ve korunduğunu açıklar."],
    },
    {
      h: "2. Toplanan Bilgiler",
      list: ["Ad Soyad", "Telefon Numarası", "E-posta Adresi", "IP Adresi", "Cihaz Bilgileri", "Tarayıcı Bilgileri", "Konum Bilgisi", "Facebook Lead Form bilgileri", "WhatsApp üzerinden paylaşılan bilgiler", "Çerezler (Cookies)", "Facebook Pixel ve benzeri analiz verileri"],
    },
    {
      h: "3. Kullanım Amaçları",
      list: ["Hizmet sunmak", "İletişime geçmek", "Kampanya ve duyurular göndermek", "Reklam performansını analiz etmek", "Hizmeti geliştirmek", "Yasal yükümlülükleri yerine getirmek"],
    },
    { h: "4. Facebook ve Meta Teknolojileri", p: ["Facebook Pixel, Meta Conversion API, Lead Ads, Messenger ve Instagram reklam teknolojileri kullanılabilir."] },
    { h: "5. Çerezler", p: ["Site performansı, analiz ve reklam optimizasyonu amacıyla çerezler kullanılabilir."] },
    { h: "6. Bilgilerin Paylaşılması", p: ["Yasal zorunluluklar dışında bilgiler üçüncü kişilere satılmaz. Hizmet sağlayıcılarla gerekli ölçüde paylaşılabilir."] },
    { h: "7. Veri Güvenliği", p: ["SSL, güvenlik duvarları ve yetkilendirme sistemleri kullanılmaktadır."] },
    { h: "8. Saklama Süresi", p: ["Veriler gerekli olduğu süre boyunca saklanır ve sonrasında silinir veya anonimleştirilir."] },
    { h: "9. Haklarınız", p: ["Verilerinize erişme, düzeltme, silme ve işlemeye itiraz etme haklarına sahipsiniz."] },
    { h: "10. İletişim", p: ["E-posta: info@trhisseborsalari.com", "Telefon: + 05391180130"] },
    { h: "Facebook Lead Form Kısa Gizlilik Metni", p: ["Bu form aracılığıyla paylaştığınız kişisel bilgiler yalnızca sizinle iletişime geçmek ve talep ettiğiniz hizmet hakkında bilgi vermek amacıyla kullanılacaktır. Bilgileriniz üçüncü kişilerle satılmaz veya paylaşılmaz. Detaylı bilgi için Gizlilik Politikamızı inceleyebilirsiniz."] },
  ],
};

export const AGREEMENT = {
  title: "Kullanıcı Sözleşmesi",
  updated: "",
  sections: [
    { h: "1. Gizlilik Politikası", p: ["Kişisel veriler; iletişim, hizmet sunumu, reklam optimizasyonu, yasal yükümlülüklerin yerine getirilmesi amacıyla işlenebilir. Toplanabilecek veriler: ad soyad, telefon, e-posta, IP, cihaz bilgileri, çerez verileri ve Meta Lead Form bilgileri. Veriler gerekli süre boyunca güvenli şekilde saklanır ve üçüncü kişilere yalnızca yasal zorunluluk veya hizmet sağlayıcı desteği kapsamında aktarılır."] },
    { h: "2. KVKK Aydınlatma Metni", p: ["6698 sayılı KVKK kapsamında veri sorumlusu olarak kişisel verileriniz açık rıza veya kanuni sebeplere dayanılarak işlenebilir. Başvuru, düzeltme, silme ve itiraz haklarınızı şirket iletişim adreslerinden kullanabilirsiniz."] },
    { h: "3. Çerez Politikası", p: ["Web sitesi zorunlu, performans, analiz ve reklam çerezleri kullanabilir. Tarayıcı ayarlarınızdan çerez tercihlerinizi değiştirebilirsiniz."] },
    { h: "4. Kullanım Şartları", p: ["Siteyi kullanan herkes bu şartları kabul etmiş sayılır. İçerikler izinsiz kopyalanamaz. Hizmetler önceden haber verilmeksizin değiştirilebilir."] },
    { h: "5. Mesafeli Satış Sözleşmesi", p: ["Elektronik ortamda verilen siparişlerde tarafların hak ve yükümlülükleri, teslimat, ödeme, cayma hakkı ve uyuşmazlık hükümleri ilgili mevzuata uygun olarak uygulanır."] },
    { h: "6. İptal ve İade Politikası", p: ["İptal ve iade koşulları satılan ürün veya hizmetin niteliğine göre yürürlükteki tüketici mevzuatı çerçevesinde uygulanır. Dijital hizmetlerde istisnalar geçerli olabilir."] },
    { h: "7. Facebook Lead Form Gizlilik Metni", p: ["Bu formda paylaştığınız bilgiler yalnızca talebinizi karşılamak ve sizinle iletişime geçmek amacıyla kullanılacaktır. Bilgileriniz satılmaz. Detaylar Gizlilik Politikasında yer almaktadır."] },
  ],
};
